import { BeanDestinatarios } from "./BeanDestinatarios";

export class BeanOperacao{
  constructor(
    public operIdCdOperacao  : string,
    public operNmOperacao	 : string,
    public operDsCentroCusto : string,
    public operDhRegistro	 : string,
    public operDhInativo	 : string,
    public destinatarios : BeanDestinatarios[]

  ){}
}